import React from "react";
import cx from "classnames";
import PropTypes from "prop-types";

import styles from "./Card.css";

const CardBlock = ({ children, className }) => (
  <div className={cx(styles.block, className)}>{children}</div>
);

CardBlock.propTypes = {
  children: PropTypes.node,
  className: PropTypes.string,
};

export default CardBlock;
